'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppDownloadIcons = exports.IOS = exports.ANDROID = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _reactIntl = require('react-intl');

var _urls = require('constants/urls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_APP_IOS = require('../../../style-guide/templates/static/assets/images/css/download-appstore.svg');
var ICON_APP_ANDROID = require('../../../style-guide/templates/static/assets/images/css/download-playstore.svg');

var ANDROID = exports.ANDROID = 'android';
var IOS = exports.IOS = 'ios';

var AppDownloadIcons = exports.AppDownloadIcons = function (_PureComponent) {
  (0, _inherits3.default)(AppDownloadIcons, _PureComponent);

  function AppDownloadIcons() {
    (0, _classCallCheck3.default)(this, AppDownloadIcons);
    return (0, _possibleConstructorReturn3.default)(this, (AppDownloadIcons.__proto__ || (0, _getPrototypeOf2.default)(AppDownloadIcons)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppDownloadIcons, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          extraClass = _props.extraClass,
          handleClick = _props.onClick;


      return _react2.default.createElement(
        'ul',
        { className: (0, _classnames2.default)('app-download-icons', extraClass) },
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            {
              target: '_blank',
              rel: 'noopener noreferrer',
              href: _urls.URL_APP_IOS,
              onClick: handleClick && handleClick.bind(null, IOS)
            },
            _react2.default.createElement(
              _reactInlinesvg2.default,
              { className: 'svg', uniquifyIDs: false, src: ICON_APP_IOS },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'app-download-icons.download-link',
                defaultMessage: 'Download ClassPass for iPhone'
              })
            )
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'a',
            {
              target: '_blank',
              rel: 'noopener noreferrer',
              href: _urls.URL_APP_ANDROID,
              onClick: handleClick && handleClick.bind(null, ANDROID)
            },
            _react2.default.createElement(
              _reactInlinesvg2.default,
              { className: 'svg', uniquifyIDs: false, src: ICON_APP_ANDROID },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'app-download-icons.download-link-android',
                defaultMessage: 'Download ClassPass for Android'
              })
            )
          )
        )
      );
    }
  }]);
  return AppDownloadIcons;
}(_react.PureComponent);

AppDownloadIcons.propTypes = {
  extraClass: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};